
<template>
<section class="make-payment">
  <div>
    <div class="columns payment-columns">
      <div class="col">
        <dl>
          <dt class="data-label">Check Amount</dt>
          <dd class="data-content"> {{ formatCurrency(check_amount) }} </dd>
        </dl>
        <chc-input class="left" v-model="data.check_number" :error="errors.check_number" label="Check Number" :required="true"></chc-input>
        <chc-input class="left" v-model="data.check_date" :error="errors.check_date" label="Check Date" type="date" :required="true"></chc-input>
        <span>Select proceeds to pay with this check</span>
        <span v-if="errors.donation_ids" class="error-message error-block">Must select at least one vehicle to pay</span>
      </div>
      <div class = "col company-info">
        <dl>
          <dt class="data-label">{{ charityId ? 'Charity' : 'Towing Company' }}</dt>
        </dl>
        <div class="field">
          <span>{{ name }}</span>
        </div>
        <div class="field">
          <span>{{ address_street }}</span>
        </div>
        <div class="field">
          <span>{{ address_city_state }}</span>
          <span>{{ address_zip }}</span>
        </div>
      </div>
    </div>
    <div v-if="charityId" class="table-no-search">
      <datatable
        :source='charityProceeds'
        :filterable="false"
        :isLoading='isLoading'>
        <datatable-column
          v-for='(column, index) in charityColumns'
          :id='column.id'
          :label='column.label'
          :key='index'
          >
        </datatable-column>
        <template slot="searchLeft">
        </template>
        <template slot="source_template" slot-scope="data">
          <tr>
            <td class="table-checkbox"><chc-checkbox v-model="data.row.pay"></chc-checkbox></td>
            <td>{{ data.row.ref_number }}</td>
            <td>{{ data.row.vehicle }}</td>
            <td>{{ data.row.donor }}</td>
            <td>{{ data.row.sale_price }}</td>
            <td>{{ data.row.auction_fee }}</td>
            <td>{{ data.row.conditioning_fee }}</td>
            <td>{{ data.row.processing_fee }}</td>
            <td>{{ data.row.repair_cost }}</td>
            <td>{{ data.row.tow_expense }}</td>
            <td>{{ data.row.gross_proceeds }}</td>
            <td>{{ data.row.charity_proceeds }}</td>
          </tr>
        </template>
        <template slot="tfoot" slot-scope="data">
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>TOTAL DUE</td>
            <td>{{ total_charity_proceeds }}</td>
          </tr>
        </template>
      </datatable>
    </div>
    <div v-if="towingCompanyId" class="table-no-search">
      <datatable
        :source='towingCompanyProceeds'
        :filterable="false"
        :isLoading='isLoading'>
        <datatable-column
          v-for='(column, index) in towingColumns'
          :id='column.id'
          :label='column.label'
          :key='index'
          >
        </datatable-column>
        <template slot="searchLeft">
        </template>
        <template slot="source_template" slot-scope="data">
          <tr>
            <td class="table-checkbox"><chc-checkbox v-model="data.row.pay"></chc-checkbox></td>
            <td>{{ data.row.ref_number }}</td>
            <td>{{ data.row.tow_date }}</td>
            <td>{{ data.row.vehicle }}</td>
            <td>{{ data.row.pickup_location }}</td>
            <td>{{ data.row.destination }}</td>
            <td>{{ data.row.towing_fee }}</td>
          </tr>
        </template>
        <template slot="tfoot" slot-scope="data">
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>TOTAL DUE</td>
            <td>{{ total_towing_fee }}</td>
          </tr>
        </template>
      </datatable>
    </div>
    <div class="field buttons left">
      <input type="submit" class="btn" value="Apply Payment" @click="submit">
    </div>
  </div>
</section>
</template>

<script>
import store from '@/store'
import Datatable from '@/components/Datatables/AppDatatable'
import DatatableColumn from '@/components/Datatables/AppDatatableColumn'
import _ from 'lodash'

export default {
  name: 'MakePayment',
  mounted () {
    this.refresh()
  },
  data () {
    return {
      data: {
        check_number: null,
        check_date: null,
      },
      hasErrors: false,
      errors: {},

      name: null,
      address_street: null,
      address_city_state: null,
      address_zip: null,

      charityColumns: [
        { id: 'pay', label: 'Pay' },
        { id: 'ref_number', label: 'Ref #' },
        { id: 'vehicle', label: 'Vehicle' },
        { id: 'donor', label: 'Donor Name' },
        { id: 'sale_price', label: 'Sale Price' },
        { id: 'auction_fee', label: 'Auction Fee' },
        { id: 'conditioning_fee', label: 'Miscellaneous Fee' },
        { id: 'processing_fee', label: 'Processing Fee' },
        { id: 'repair_cost', label: 'Repair Cost' },
        { id: 'tow_expense', label: 'Tow & Expense' },
        { id: 'gross_proceeds', label: 'Adj. Gross Proceeds' },
        { id: 'charity_proceeds', label: 'Charity Proceeds' }
      ],
      towingColumns: [
        { id: 'pay', label: 'Pay' },
        { id: 'ref_number', label: 'Ref #' },
        { id: 'tow_date', label: 'Tow Date' },
        { id: 'vehicle', label: 'Vehicle' },
        { id: 'pickup_location', label: 'Pickup Location' },
        { id: 'destination', label: 'Destination' },
        { id: 'towing_fee', label: 'Towing Fee' }
      ],
      charityProceeds: [],
      towingCompanyProceeds: [],
      total_charity_proceeds: null,
      total_towing_fee: null,
      isLoading: false
    }
  },
  props: ['charityId', 'towingCompanyId'],
  methods: {
    refresh () {
      if (this.charityId) {
        this.isLoading = true
        Promise.all([
          store.functions.charity.getUnpaidProceeds(this.charityId,
            (response) => {
              this.charityProceeds = response.data.table_data
              this.total_charity_proceeds = response.data.total
              this.name = response.data.name
              this.address_street = response.data.address_street
              this.address_city_state = response.data.address_city_state
              this.address_zip = response.data.address_zip
            }
          ),
        ]).then(() => {
          this.isLoading = false
        })
      }
      if (this.towingCompanyId) {
        this.isLoading = true
        Promise.all([
          store.functions.towingCompanies.getUnpaidProceeds(this.towingCompanyId,
            (response) => {
              this.towingCompanyProceeds = response.data.table_data
              this.total_towing_fee = response.data.total
              this.name = response.data.name
              this.address_street = response.data.address_street
              this.address_city_state = response.data.address_city_state
              this.address_zip = response.data.address_zip
            }
          )
        ]).then(() => {
          this.isLoading = false
        })
      }
    },
    submit () {
      if (this.charityId) {
        store.functions.charity.makePayment(
          this.charityId,
          {
            check_date: this.data.check_date,
            check_number: this.data.check_number,
            check_amount_cents: this.check_amount,
            donation_ids: this.donationIds
          },
          (errors) => {
            this.errors = errors
            this.hasErrors = true
          }).then(() => {
          this.hasErrors = false
          this.$emit('refresh')
          this.$emit('close')
        })
      }
      if (this.towingCompanyId) {
        store.functions.towingCompanies.makePayment(
          this.towingCompanyId,
          {
            check_date: this.data.check_date,
            check_number: this.data.check_number,
            check_amount_cents: this.check_amount,
            donation_ids: this.donationIds
          },
          (errors) => {
            this.errors = errors
            this.hasErrors = true
          }).then(() => {
          this.hasErrors = false
          this.$emit('refresh')
          this.$emit('close')
        })
      }
    },
    formatCurrency (val) {
      return '$' + (+val / 100).toFixed(2)
    }
  },
  computed: {
    tableData () {
      if (this.charityId) return this.charityProceeds
      if (this.towingCompanyId) return this.towingCompanyProceeds
    },
    check_amount () {
      if (this.charityId) {
        return _.reduce(this.tableData, function (sum, row) {
          if (row.pay) return sum + parseInt(row.charity_proceeds_cents)
          else return sum
        }, 0)
      }
      if (this.towingCompanyId) {
        return _.reduce(this.tableData, function (sum, row) {
          if (row.pay) return sum + parseInt(row.tow_fee_cents)
          else return sum
        }, 0)
      }
    },
    donationIds () {
      let ids = []
      for (var i = this.tableData.length - 1; i >= 0; i--) {
        if (this.tableData[i].pay) ids.push(this.tableData[i].donation_id)
      }
      if (ids.length > 0) return ids
      return null
    }
  },
  components: {
    Datatable,
    DatatableColumn
  }
}
</script>

<style lang="scss" scoped>
  td.table-checkbox, td.table-checkbox * {
    width: 25px;
  }

  .payment-columns {
    display: flex;
  }

  .company-info {
    margin-left: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Payables/MakePayment.vue